import { render, staticRenderFns } from "./telaDeSucesso.vue?vue&type=template&id=4fe06add&scoped=true"
import script from "./telaDeSucesso.vue?vue&type=script&lang=js"
export * from "./telaDeSucesso.vue?vue&type=script&lang=js"
import style0 from "./telaDeSucesso.vue?vue&type=style&index=0&id=4fe06add&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe06add",
  null
  
)

export default component.exports